import { jsxs as p, jsx as c } from "react/jsx-runtime";
import '../../assets/StepItem.css';const m = "_stepItem_ywmhz_1", o = "_copy_ywmhz_20", t = {
  stepItem: m,
  copy: o
}, r = ({ Icon: e, copy: s }) => /* @__PURE__ */ p("li", { className: `${t.stepItem} iOSPWA-stepItem`, children: [
  e,
  /* @__PURE__ */ c("p", { className: t.copy, children: s })
] });
export {
  r as StepItem
};
